import { reactionDisplay } from '@/lib/reactionPictures';

// ============================================================================
// ReactionGlyph — глиф реакции: SVG из «Картинок», а при недоступной
// библиотеке — встроенный эмодзи-символ того же SSoT-реестра (reactionDisplay).
// Неизвестный код НЕ рендерится (сервер нормализует старые unicode-значения).
// Вынесен из MessageBubble (SRP; см. использование в чипах реакций).
// ============================================================================

export function ReactionGlyph({ value, size }: { value: string; size: number }) {
  const { url, char } = reactionDisplay(value);
  if (url) {
    return <img src={url} alt="" draggable={false} style={{ width: size, height: size }} className="inline-block object-contain align-[-3px]" />;
  }
  if (!char) return null;
  return (
    <span
      style={{ width: size, height: size, fontSize: Math.round(size * 0.9) }}
      className="inline-flex items-center justify-center leading-none align-[-3px]"
    >
      {char}
    </span>
  );
}
